
export default {
    name: 'RetailerSignupFooter',

    props: {
        backUrl: {
            type: String,
            default: '',
        },
        backButtonText: {
            type: String,
            default: '',
        },
        userErrors: {
            type: Array,
            default: () => [],
        },
        serverErrors: {
            type: Object,
            default: () => {},
        },
        buttonDisabled: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        nextButtonText: {
            type: String,
            default: '',
        },
    },

    computed: {
        hasUniqueError() {
            return this.userErrors?.some(
                (error) => error.failed && error.failed.includes('unique')
            )
        },
    },

    methods: {
        showLoginButton() {
            if (!Array.isArray(this.serverErrors)) {
                return false
            }

            return this.serverErrors.some((error) =>
                error?.failed?.includes('unique')
            )
        },
    },
}
